import * as z from "zod";

export const createOneTimePasscode = {
  name: "createOneTimePasscode" as const,
  input: z.object({ email: z.string(), teamId: z.string() }),
  output: z.object({ fourDigitCodeId: z.string() }),
};
